window.jQuery = window.$ =  require('jquery');
window.UIkit = require('uikit');
import Icons from 'uikit/dist/js/uikit-icons';
UIkit.use(Icons);
require('./style.scss');
require('./js/script.js');

